<template>
  <div class="container course-container" v-if="currencies.length">
    <div class="row row-full-width">
      <div class="course-wrap">
        <div class="course marquee">
          <div class="marquee__inner" aria-hidden="true">
            <template v-for="currency in currencies">
              <span :key="currency.code">
                <span class="course-item"> {{ currency.name }}</span>
                {{ currency.value }}
                <img src="../../assets/img/course-icon-up.svg" v-if="currency.up">
                <img src="../../assets/img/course-icon-down.svg" v-else>
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data: () => {
    return {
      currencies: []
    }
  },
  async created() {
    this.currencies = await this.getCurrencies();
  },
  methods: {
    async getCurrencies() {
      const response = await axios.get('https://www.cbr-xml-daily.ru/daily_json.js');
      if (response?.data?.Valute) {
        return Object.values(response.data.Valute).map(item => {
          return {
            code: item.CharCode,
            name: item.CharCode + ' ЦБ',
            value: ((Math.round((item.Value + Number.EPSILON) * 100) / 100) + '').replace('.', ','),
            up: item.Value - item.Previous > 0
          }
        });
      }
      return [];
    }
  }
}
</script>

<style scoped>
.___redesign .new-journal .container.course-container {
  max-width: 1232px;
  padding: 0;
}

@media screen and (max-width: 650px) {
  .___redesign .new-journal .container.course-container {
    width: 100%;
  }

  .course-container .course.marquee {
    padding-top: 16px;
    border-top: 1px solid #f5f5f5;
  }
}
</style>